import { Routes, Route, useNavigate } from "react-router-dom";
import Pages from "./pages";
import { useEffect } from "react";
import { resetAuth, setCredentials } from "./reducers/authSlice";
import { getFromStorage } from "./helpers/storage";
import { STORAGE_KEYS } from "./constants/storageKeys";
import { useAppDispatch } from "./hooks/store";
import useAuth from "./hooks/useAuth";
import { ROLES } from "./utils/enums";

const Routing = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAuth();

  useEffect(() => {
    if (
      window.location.pathname === "/privacy-policy" ||
      window.location.pathname === "/delete-policy" ||
      window.location.pathname === "/contact-support"
    ) {
      return;
    }
    const token = getFromStorage(STORAGE_KEYS.token);
    if (token && window.location.pathname === "/") {
      dispatch(
        setCredentials({
          token: `${token}`,
          user: null,
        })
      );
      navigate("/dashboard", { replace: true });
    } else if (!token && window?.location?.pathname === "/") {
      dispatch(resetAuth());
      navigate("/", { replace: true });
    } else if (token) {
      dispatch(
        setCredentials({
          token: `${token}`,
          user: null,
        })
      );
      navigate(window?.location?.pathname);
    } else {
      dispatch(resetAuth());
      navigate("/", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route path="/dashboard" element={<Pages.Dashboard />} />
      <Route path="/permission-denied" element={<Pages.PermissionDenied />} />
      <Route path="/manage-customers" element={<Pages.ManageCustomers />} />
      <Route
        path="/manage-customers/detail/:id"
        element={<Pages.ManageCustomerDetail />}
      />
      <Route path="/manage-customers/add" element={<Pages.AddCustomer />} />
      <Route
        path="/manage-customers/issues/:id"
        element={<Pages.ManageCustomerIssues />}
      />
      <Route
        path="/manage-customers/edit/:id"
        element={<Pages.AddCustomer />}
      />
      <Route
        path="/manage-maintenance-team"
        element={<Pages.ManageMaintenanceTeam />}
      />
      <Route
        path="/manage-maintenance-team/detail/:id"
        element={<Pages.MaintenanceTeamDetail />}
      />
      <Route
        path="/manage-maintenance-team/edit/:id"
        element={<Pages.AddTeam />}
      />
      <Route path="/manage-maintenance-team/add" element={<Pages.AddTeam />} />
      <Route path="/manage-issues" element={<Pages.ManageIssues />} />
      <Route
        path="/manage-issues/offers/:id"
        element={<Pages.ManageOffers />}
      />
      <Route path="/manage-categories" element={<Pages.ManageCategories />} />
      <Route path="/manage-payments" element={<Pages.ManagePayments />} />
      {/* sub-admin routes */}
      <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
      <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
      <Route path="/manage-subadmin/edit/:id" element={<Pages.AddSubadmin />} />
      <Route
        path="/manage-subadmin/detail/:id"
        element={<Pages.SubadminDetail />}
      />
      <Route
        path="/manage-subadmin/roles"
        element={<Pages.ManageSubadminRoles />}
      />
      <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
      <Route
        path="/manage-subadmin/roles/edit/:id"
        element={<Pages.AddRole />}
      />
      <Route
        path="/manage-subadmin/roles/detail/:id"
        element={<Pages.RoleDetail />}
      />
      <Route path="/revenue-analytics" element={<Pages.ManageAnalytics />} />
      <Route
        path="/manage-customer-support"
        element={<Pages.ManageCustomerSupport />}
      />
      <Route
        path="/manage-notifications"
        element={<Pages.ManageNotifications />}
      />
      <Route
        path="/recieved-notifications"
        element={<Pages.RecievedNotifications />}
      />
      <Route path="/manage-reviews" element={<Pages.ManageReviews />} />
      <Route path="/manage-cms" element={<Pages.ManageCms />} />
      <Route path="/manage-profile" element={<Pages.ManageProfile />} />
      <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
      <Route
        path="/manage-profile/change-password"
        element={<Pages.ChangePassword />}
      />
      <Route path="/privacy-policy" element={<Pages.PrivacyPolicyUrl />} />
      <Route path="/delete-policy" element={<Pages.DeletePolicy />} />
      <Route path="/contact-support" element={<Pages.ContactSupport />} />
    </Routes>
  );
};

export default Routing;
